/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, InlineLoading } from '@carbon/react';

var SidePanelControls = function SidePanelControls(_ref) {
  var cancelText = _ref.cancelText,
    doneText = _ref.doneText,
    nextId = _ref.nextId,
    nextText = _ref.nextText,
    onCancel = _ref.onCancel,
    onNext = _ref.onNext,
    onDone = _ref.onDone,
    onPrevious = _ref.onPrevious,
    previousText = _ref.previousText,
    primaryButtonDisabled = _ref.primaryButtonDisabled,
    primaryButtonDanger = _ref.primaryButtonDanger,
    renderPrimaryButton = _ref.renderPrimaryButton,
    secondaryButtonDisabled = _ref.secondaryButtonDisabled,
    previousId = _ref.previousId,
    doneIsLoading = _ref.doneIsLoading,
    doneIsLoadingText = _ref.doneIsLoadingText;
  return /*#__PURE__*/React.createElement("div", {
    className: "cds--btn-set cpc--side-panel__btn-set"
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: secondaryButtonDisabled || doneIsLoading,
    kind: "secondary",
    onClick: previousId ? function (e) {
      return onPrevious(e, previousId);
    } : onCancel,
    className: "cpc--side-panel__button"
  }, previousId ? previousText : cancelText), renderPrimaryButton && !doneIsLoading && /*#__PURE__*/React.createElement(Button, {
    disabled: primaryButtonDisabled,
    kind: primaryButtonDanger ? 'danger' : 'primary',
    onClick: nextId ? function (e) {
      return onNext(e, nextId);
    } : onDone,
    className: "cpc--side-panel__button"
  }, nextId ? nextText : doneText), doneIsLoading && /*#__PURE__*/React.createElement(InlineLoading, {
    description: doneIsLoadingText
  }));
};
SidePanelControls.propTypes = {
  cancelText: PropTypes.string.isRequired,
  doneText: PropTypes.string.isRequired,
  nextId: PropTypes.string,
  nextText: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  previousText: PropTypes.string.isRequired,
  primaryButtonDisabled: PropTypes.bool.isRequired,
  primaryButtonDanger: PropTypes.bool,
  renderPrimaryButton: PropTypes.bool.isRequired,
  secondaryButtonDisabled: PropTypes.bool.isRequired,
  previousId: PropTypes.string,
  doneIsLoading: PropTypes.bool.isRequired,
  doneIsLoadingText: PropTypes.string.isRequired
};
var SidePanelControls$1 = SidePanelControls;

export { SidePanelControls$1 as default };
